module.exports = __webpack_public_path__ + "static/img/1_1_4.41aaeba2.jpg";